import React from 'react';
import { IIconProps } from './add';

interface IIconVisible extends IIconProps {
  width?: string;
  height?: string;
}

export const IconVisible = ({
  style = {},
  cy,
  height = '13',
  width = '14',
}: IIconVisible) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`VisibleIcon${cy}`}
    >
      <path
        d="M6.99992 0.125C4.08325 0.125 1.59242 1.93917 0.583252 4.5C1.59242 7.06083 4.08325 8.875 6.99992 8.875C9.91659 8.875 12.4074 7.06083 13.4166 4.5C12.4074 1.93917 9.91659 0.125 6.99992 0.125ZM6.99992 7.41667C5.38992 7.41667 4.08325 6.11 4.08325 4.5C4.08325 2.89 5.38992 1.58333 6.99992 1.58333C8.60992 1.58333 9.91659 2.89 9.91659 4.5C9.91659 6.11 8.60992 7.41667 6.99992 7.41667ZM6.99992 2.75C6.03159 2.75 5.24992 3.53167 5.24992 4.5C5.24992 5.46833 6.03159 6.25 6.99992 6.25C7.96825 6.25 8.74992 5.46833 8.74992 4.5C8.74992 3.53167 7.96825 2.75 6.99992 2.75Z"
        fill="#BBC1C9"
      />
    </svg>
  );
};
